import { CircleLoading } from 'react-loadingg';
import { usePromiseTracker } from 'react-promise-tracker';
import { temaClaro } from '../../styles/tema';
import { Conteiner } from './styles';

export function Carregando() {
  const { promiseInProgress } = usePromiseTracker();
  return (
    promiseInProgress && (
      <Conteiner>
        <CircleLoading color={temaClaro['PRIMARY']} />
      </Conteiner>
    )
  );
}
